"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibleScrollbar = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.VisibleScrollbar = function (_a) {
    var className = _a.className, children = _a.children, restProps = tslib_1.__rest(_a, ["className", "children"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default("gd-visible-scrollbar", className) }, restProps), children));
};
//# sourceMappingURL=VisibleScrollbar.js.map